/* =========================================
   SOC 2 SEAL

   Drawn inline so it inherits the site's ink colour and serif, and
   so it stays crisp at any size. Deliberately NOT the AICPA mark:
   that seal is licensed and may not be reproduced freely.

   Shared between /security and the homepage trust band. It lived in
   security/page.tsx until the homepage needed it too; a fifty line
   SVG copied into two files is a drift waiting to happen.
   ========================================= */
export function Soc2Badge({
  className = 'soc2-badge reveal reveal-scale',
}: {
  /* Callers override to change size or drop the reveal animation. */
  className?: string
}) {
  return (
    <svg
      className={className}
      viewBox="0 0 140 140"
      role="img"
      aria-label="SOC 2 Type II"
    >
      <circle cx="70" cy="70" r="67" fill="none" stroke="currentColor" strokeWidth="1.5" />
      <circle cx="70" cy="70" r="45" fill="none" stroke="currentColor" strokeWidth="0.75" />
      <defs>
        {/* Top arc: 220° over the crown, glyph tops face out */}
        <path
          id="soc2-arc-top"
          d="M 17.4 89.2 A 56 56 0 1 1 122.6 89.2"
          fill="none"
        />
        {/* Bottom arc: 160° under the base, glyph tops face in,
            so the text reads upright at the bottom of the seal */}
        <path
          id="soc2-arc-bot"
          d="M 13.9 79.9 A 57 57 0 0 0 126.1 79.9"
          fill="none"
        />
      </defs>
      <text fill="currentColor" fontSize="9" letterSpacing="1.4" style={{ fontFamily: 'var(--font-sans)' }}>
        <textPath href="#soc2-arc-top" startOffset="50%" textAnchor="middle">
          SERVICE ORGANIZATION CONTROLS
        </textPath>
      </text>
      <text fill="currentColor" fontSize="9" letterSpacing="1.4" style={{ fontFamily: 'var(--font-sans)' }}>
        <textPath href="#soc2-arc-bot" startOffset="50%" textAnchor="middle">
          INDEPENDENTLY AUDITED
        </textPath>
      </text>
      <text
        x="70"
        y="76"
        textAnchor="middle"
        fill="currentColor"
        fontSize="27"
        style={{ fontFamily: 'var(--font-eb-garamond), Georgia, serif' }}
      >
        SOC 2
      </text>
      <text
        x="70"
        y="92"
        textAnchor="middle"
        fill="currentColor"
        fontSize="8.5"
        letterSpacing="2.5"
        style={{ fontFamily: 'var(--font-sans)' }}
      >
        TYPE II
      </text>
    </svg>
  )
}
